import { Dialog, DialogTitle, Divider, IconButton } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import React from 'react'

const CartLayout = ({ showCart, handleClose, children, mobile }) => {
  const styles = {
    dialog: {},
    dialogTitle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      '&.MuiDialogTitle-root': {}
    },
    dialogContent: {
      overflowY: 'auto',
      display: 'grid',
      gridTemplateColumns: '60% 40%',
      gridTemplateRows: 'auto auto',
      '&.MuiDialogContent-root': { padding: '0px' },
      minWidth: '50vw'
    },
    dialogActions: {
      justifyContent: 'flex-end',
      width: '100%',
      '&.MuiDialogActions-root': { padding: '8px 24px 16px 24px' }
    }
  }
  return (
    <>
      <Dialog
        PaperProps={{
          sx: {
            width: mobile ? '100vw' : '70vw',
            maxWidth: mobile ? '100vw' : '70vw'
          }
        }}
        sx={styles.dialog}
        open={showCart}
        scroll='body'
        onClose={handleClose}
        fullScreen={mobile}
      >
        <DialogTitle sx={styles.dialogTitle}>
          Shopping Cart
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <Divider />
        {children}
      </Dialog>
    </>
  )
}

export default CartLayout
